<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md5 v-if="!currentPallet">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important; display: inline-flex; width: 350px; margin-right: 25px;"></v-text-field>
            <div style="display: inline-block;">
              <v-btn flat @click="previousPage" class="bw-3" v-if="lastPage > 1 && !isShowingProducedPallets" :disabled="currentPage === 1">Page {{ currentPage > 1 ? currentPage-1 : currentPage }}</v-btn>
              <v-btn flat @click="nextPage" class="bw-3" v-if="lastPage > 1 && !isShowingProducedPallets" :disabled="currentPage === lastPage" style="margin-right: 30px;">Page {{ currentPage+1 }}</v-btn>
            </div>
          </v-flex>
          <v-flex text-xs-right xs12 md7 v-if="!currentPallet">
            <v-btn flat @click="print" class="bw-3" style="margin-right: 25px;" :disabled="!canPrint">Print</v-btn>
            <v-btn flat @click="filterByPlanned" class="bw-3_5" :style="buttonStylePlanned" :disabled="filterGroup === 'PLANNED'">Planned</v-btn>
            <v-btn flat @click="filterByProduced" class="bw-3_5" :style="buttonStyleProduced" :disabled="filterGroup === 'PRODUCED'">Produced</v-btn>
            <v-btn flat @click="filterByDelivered" class="bw-3_5" :style="buttonStyleDelivered" :disabled="filterGroup === 'DELIVERED'">Delivered</v-btn>
            <v-btn flat @click="filterByRepacked" class="bw-3_5" :style="buttonStyleRepacked" :disabled="filterGroup === 'REPACKED'">Repacked</v-btn>
            <v-btn flat @click="filterByDeleted" class="bw-3_5" :style="buttonStyleDeleted" :disabled="filterGroup === 'DELETED'">Deleted</v-btn>
            <v-btn flat @click="editNewPallet" class="bw-6" style="margin-left: 50px;">Create new pallet</v-btn>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 20px;" v-if="!currentPallet">
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadPallets"></v-autocomplete>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 20px;" v-if="!currentPallet">
            <v-autocomplete :items="categories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadPallets">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 20px;" v-if="!currentPallet">
            <v-autocomplete :items="shipmentNumbers" v-model="filterShipmentNumber" prepend-icon="a-boxes" return-object @change="loadPallets" class="shipmentNumbers"></v-autocomplete>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 20px;" v-if="!currentPallet">
            <v-autocomplete :items="locations" v-model="filterLocation" item-text="text" prepend-icon="a-address" return-object @change="loadPallets" class="shipmentNumbers"></v-autocomplete>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentPallet">
            <v-btn flat @click="startViewInternalTransportLog" class="bw-6" style="float: left;" v-if="currentPallet.id > 0 && !viewInternalTransportLog && !viewLog">Internal transport</v-btn>
            <v-btn flat @click="startViewLog" class="bw-3" style="float: left;" v-if="currentPallet.id > 0 && !viewInternalTransportLog && !viewLog">Log</v-btn>
            <v-btn flat @click="create" :disabled="createButtonDisabled" class="bw-3" v-if="currentPallet.id === 0 && !viewInternalTransportLog && !viewLog">Create</v-btn>
            <v-btn flat @click="save" :disabled="saveButtonDisabled" class="bw-3" v-if="currentPallet.id > 0 && !viewInternalTransportLog && !viewLog">Save</v-btn>
            <v-btn flat @click="addCategory" class="bw-5" v-if="!viewInternalTransportLog && !viewLog">Add category</v-btn>
            <v-btn flat @click="confirmDeleteDialog = true" v-if="canDelete && !viewInternalTransportLog && !viewLog" class="bw-3">Delete</v-btn>
            <v-btn flat @click="startCreateInternalTransportLog" class="bw-9" style="float: left;" v-if="currentPallet.id > 0 && viewInternalTransportLog && !currentInternalTransportLog">Create internal transport action</v-btn>
            <v-btn flat @click="saveInternalTransportLog" :disabled="!saveInternalTransportLogButtonEnabled" class="bw-3" v-if="currentPallet.id > 0 && viewInternalTransportLog && currentInternalTransportLog">Save</v-btn>
            <v-btn flat @click="cancelCreateInternalTransportLog" class="bw-3" v-if="currentPallet.id > 0 && viewInternalTransportLog && currentInternalTransportLog">Cancel</v-btn>
            <v-btn flat @click="cancel" class="bw-3" v-if="!viewInternalTransportLog && !viewLog">Close</v-btn>
            <v-btn flat @click="endViewInternalTransportLog" class="bw-3" v-if="viewInternalTransportLog && !currentInternalTransportLog">Close</v-btn>
            <v-btn flat @click="endViewLog" class="bw-3" v-if="viewLog">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentPallet" >
        <v-layout style="max-height: calc(100vh - 220px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="tableHeaders" :items="pagedPallets" ref="pallets" disable-initial-sort hide-actions class="palletTable" no-data-text="No pallets found">
              <template v-slot:items="props">
                <tr @click="selectPallet(props.item)" :class="rowColor(props.item)">
                  <td class="text-xs-left" style="padding-top: 1px !important;">{{ props.item.number }}</td>
                  <td class="text-xs-left" style="padding-top: 1px !important;">{{ props.item.externalNumber }}</td>
                  <td class="text-xs-left" style="padding-top: 1px !important;">{{ props.item.shipmentNumber ? props.item.shipmentNumber : props.item.plannedShipmentNumber }}</td>
                  <td class="text-xs-left" style="white-space: nowrap; padding-top: 1px !important;">{{ props.item.stateLabel }}</td>
                  <td class="text-xs-left" style="padding-top: 1px !important;">{{ props.item.supplier }}</td>
                  <td class="text-xs-left"><div v-html="props.item.categories"></div></td>
                  <td class="text-xs-right" style="width: 60px; white-space: nowrap; padding-top: 1px !important;"><div v-html="props.item.amounts"></div></td>
                  <td class="text-xs-left" style="white-space: nowrap; padding-top: 1px !important;">{{ props.item.pickupDate }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentPallet && !viewInternalTransportLog && !viewLog">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Pallet">
                <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="currentPallet.number">
                  <v-label>Pallet no.</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="currentPallet.number">
                  {{ currentPallet.number }}
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>External number</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-text-field v-model="currentPallet.externalNumber" maxlength="50" style="max-width: 300px;"/>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-select :items="suppliers" v-model="currentPallet.supplier" item-text="name" return-object @change="changeSupplier()"></v-select>
                </v-flex>

                <v-flex xs12 style="height: 25px;"/>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Categories</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="min-height: 35px;">
                  <v-container fluid py-0 px-0>
                    <v-layout wrap v-for="(item, i) in currentPallet.items" v-bind:key="item.id">
                      <v-flex xs12 sm5 style="height: 35px;" v-if="((item.categoryName && item.categoryName !== '') || currentPallet.createdByAdmin || item.uuid !== '') && !item.deleted">
                        <table style="width: 100%; margin-right: 25px; border-collapse: collapse;">
                          <tr>
                            <td style="width: 30%;" v-if="item.categoryName && item.categoryName !== ''">
                              {{ item.categoryName !== '' ? item.categoryName : item.category ? item.category.label : '' }}
                            </td>
                            <td>
                              <v-autocomplete :items="categories" v-model="item.category" item-text="displayLabel" return-object @change="changeCategory(item)">
                                <template slot="selection" slot-scope="data">
                                  <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                  <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                  {{ data.item.displayLabel }}
                                </template>
                                <template slot="item" slot-scope="data">
                                  <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                  <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                  {{ data.item.displayLabel }}
                                </template>
                              </v-autocomplete>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                      <v-flex xs12 sm5 style="height: 35px;" v-if="(!((item.categoryName && item.categoryName !== '') || currentPallet.createdByAdmin || item.uuid !== '')) && !item.deleted">
                        {{ item.category ? item.category.label : '' }}
                      </v-flex>
                      <v-flex xs12 sm3 style="height: 35px; padding-left: 15px;" v-if="!item.deleted">
                        <v-select :items="options" v-model="item.options" item-text="name" return-object multiple/>
                      </v-flex>
                      <v-flex xs12 sm4 style="height: 35px" v-if="!item.deleted">
                        <table style="float: right;">
                          <tr>
                            <td style="padding-right: 10px;">
                              <v-text-field v-model="item.plannedAmount" style="max-width: 70px;" text-xs-right title="Planned amount"></v-text-field>
                            </td>
                            <td style="width: 40%;">
                              <v-text-field v-model="item.amount" style="max-width: 70px;" text-xs-right title="Produced amount"></v-text-field>
                            </td>
                            <td style="padding-left: 10px; width: 35px;">
                              <v-icon v-if="canDeleteCategories" @click="confirmDeleteCategory(i)" title="Delete">delete</v-icon>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs12 style="height: 25px;"/>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-select :items="fields" v-model="currentPallet.field" item-text="address.nameAndText" return-object></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="currentPallet.createdByAdmin">
                  <v-label>Contractor</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="currentPallet.createdByAdmin">
                  <v-select :items="contractors" v-model="currentPallet.contractor" item-text="name" return-object></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Internal carrier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-select :items="internalCarriers" v-model="currentPallet.internalCarrier" item-text="name" return-object></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>&frac12; pallet</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-checkbox color="teal" v-model="currentPallet.half" style="margin-left: -2px; padding-top: 0 !important;" @change="changeHalfPallet"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Special</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  {{ currentPallet.special ? 'Yes' : 'No' }}
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>State</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="height: 35px;">
                  <v-select :items="states" v-model="currentPallet.state" item-text="label" item-value="value" style="max-width: 170px;"></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="height: 35px;">
                  <v-select :items="locations" v-model="currentPallet.location" item-text="text" return-object style="line-height: 25px; height: 30px;"></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Loading address</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="height: 35px;">
                  <v-select :items="pickupAddresses" v-model="currentPallet.pickupAddress" item-text="text" return-object style="line-height: 25px; height: 30px;"></v-select>
                </v-flex>

                <v-flex xs12 style="padding-top: 20px;" v-if="currentPallet.underProduced">
                  <div class="warningBox" style="text-align: center;">
                    This pallet has less than half the standard amount
                  </div>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentPallet && viewInternalTransportLog">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn :title="'Internal transport actions for pallet #' + this.currentPallet.palletNumber" v-if="!currentInternalTransportLog">
                <v-layout style="max-height: calc(100vh - 290px);">
                  <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                    <v-data-table :headers="internalTransportLogHeaders" :items="internalTransportLogs" hide-actions class="palletTable" no-data-text="No log actions found">
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left" style="width: 160px;">{{ props.item.timestamp }}</td>
                          <td class="text-xs-left" style="width: 100px;">{{ props.item.actionLabel }}</td>
                          <td class="text-xs-left">{{ props.item.userFullName }}</td>
                          <td class="text-xs-left">{{ props.item.address ? props.item.address.text : '' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </PanelColumn>
              <PanelColumn :title="'New internal transport action for pallet #' + this.currentPallet.palletNumber" v-if="currentInternalTransportLog">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Timestamp</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <table>
                    <tr>
                      <td>
                        <v-menu v-model="timestampDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="timestampDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"/>
                          </template>
                          <v-date-picker v-model="timestampDate" @input="timestampDateMenu = false"/>
                        </v-menu>
                      </td>
                      <td style="padding-left: 25px;">
                        <v-menu v-model="timestampTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="timestampTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on"/>
                          </template>
                          <v-time-picker v-if="timestampTimeMenu" v-model="timestampTime" :allowed-minutes="timestampAllowedSteps" class="mt-3" format="24hr" @click:minute="timestampTimeMenu = false"/>
                        </v-menu>
                      </td>
                    </tr>
                  </table>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Action</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-radio-group :row="true" v-model="currentInternalTransportLog.action">
                    <v-radio label="Loaded" value="LOAD" color="#004d40"></v-radio>
                    <div style="width: 40px;"/>
                    <v-radio label="Unloaded" value="UNLOAD" color="#004d40"></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>User</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-select :items="users" v-model="currentInternalTransportLog.userName" item-text="fullName" item-value="userName" style="line-height: 25px; height: 30px;"></v-select>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Address</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-select :items="pickupAddresses" v-model="currentInternalTransportLog.address" item-text="text" return-object style="line-height: 25px; height: 30px;"></v-select>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentPallet && viewLog">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn :title="'Log entries for pallet #' + this.currentPallet.palletNumber">
                <v-layout style="max-height: calc(100vh - 290px);">
                  <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                    <v-data-table :headers="logHeaders" :items="logs" hide-actions class="palletTable" no-data-text="No log entries found">
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left" style="width: 160px;">{{ props.item.timestamp }}</td>
                          <td class="text-xs-left">{{ props.item.userFullName }}</td>
                          <td class="text-xs-left">{{ props.item.message }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete pallet</v-card-title>
        <v-card-text v-if="currentPallet">Are you sure you want to delete this pallet?</v-card-text>
        <v-card-text v-if="currentPallet && this.currentPallet.state !== 'PLANNED'" style="padding-top: 0;">Please note that production has already started and you might loose data about this pallet.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteCategoryDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete category</v-card-title>
        <v-card-text v-if="currentPallet">Are you sure you want to delete this category?</v-card-text>
        <v-card-text v-if="currentPallet && this.currentPallet.state !== 'PLANNED'" style="padding-top: 0;">Please note that production has already started and you might loose data about this pallet.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteCategory">Yes</v-btn>
          <v-btn flat @click="confirmDeleteCategoryDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorDialog ref="errorDialog"/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import ErrorDialog from '../components/ErrorDialog'
import PanelColumn from '../components/PanelColumn'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Pallets',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, ErrorDialog },
  data () {
    return {
      search: '',
      customers: [],
      categories: [],
      shipmentNumbers: [],
      locations: [],
      pickupAddresses: [],
      pallets: [],
      currentPallet: null,
      filterCustomer: { id: 0 },
      filterSupplier: { id: 0 },
      filterCategory: { id: 0 },
      filterShipmentNumber: '',
      filterLocation: { id: 0 },
      filterGroup: null,
      currentPage: 1,
      lastPage: 0,
      headers: [
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Ext. pallet no.', value: 'externalNumber', sortable: false },
        { text: 'Shipment no.', value: 'shipmentNumber', sortable: false },
        { text: 'State', value: 'state', sortable: false },
        { text: 'Supplier', value: 'supplier', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Amount', value: 'amounts', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: false }
      ],
      producedHeaders: [
        { text: 'Pallet no.', value: 'number', sortable: true },
        { text: 'Ext. pallet no.', value: 'externalNumber', sortable: true },
        { text: 'Shipment no.', value: 'plannedShipmentNumber', sortable: true },
        { text: 'State', value: 'state', sortable: false },
        { text: 'Supplier', value: 'supplier', sortable: true },
        { text: 'Category', value: 'sortableLabel', sortable: true },
        { text: 'Amount', value: 'amounts', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: true }
      ],
      internalTransportLogHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'Action', value: 'actionLabel', sortable: false },
        { text: 'User', value: 'userFullName', sortable: false },
        { text: 'Address', value: 'address', sortable: false }
      ],
      logHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'User', value: 'userFullName', sortable: false },
        { text: 'Message', value: 'message', sortable: false }
      ],
      states: [
        { value: 'PLANNED', label: 'Planned' },
        { value: 'IN_PRODUCTION', label: 'In production' },
        { value: 'PRODUCED', label: 'Produced' },
        { value: 'READY_FOR_PICKUP', label: 'Ready for pickup' },
        { value: 'IN_TRANSPORT', label: 'In transport' },
        { value: 'REPACKED', label: 'Repacked' },
        { value: 'DELIVERED', label: 'Delivered' },
        { value: 'DELETED', label: 'Deleted' }
      ],
      confirmDeleteDialog: false,
      suppliers: [],
      filterSuppliers: [],
      fields: [],
      contractors: [],
      internalCarriers: [],
      confirmDeleteCategoryDialog: false,
      deleteCategoryIndex: 0,
      viewInternalTransportLog: false,
      currentInternalTransportLog: null,
      viewLog: false,
      internalTransportLogs: [],
      logs: [],
      timestampDate: '',
      timestampTime: '',
      timestampDateMenu: false,
      timestampTimeMenu: false,
      options: []
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'pallets' })
    this.filterByProduced()
    this.loadCustomers()
    this.loadCategories()
    this.loadShipmentNumbers()
    this.loadLocations()
    this.loadPickupAddresses()
    this.loadSuppliers()
    this.loadContractors()
    this.loadInternalCarriers()
    this.loadOptions()
  },
  computed: {
    createButtonDisabled () {
      let disabled = false
      if (!this.currentPallet.supplier) {
        disabled = true
      }
      for (let item of this.currentPallet.items) {
        if (!item.category || item.category.id === 0) {
          disabled = true
          break
        }
        if (item.amount && item.amount !== '' && !NumberUtil.isZeroOrPositiveInteger(item.amount)) {
          disabled = true
          break
        }
      }
      return disabled
    },
    saveButtonDisabled () {
      let disabled = false
      if (this.currentPallet) {
        for (let item of this.currentPallet.items) {
          if (item.amount && item.amount !== '' && !NumberUtil.isZeroOrPositiveInteger(item.amount)) {
            disabled = true
            break
          }
        }
      }
      if (this.currentPallet.createdByAdmin) {
        if (!this.currentPallet.supplier) {
          disabled = true
        }
      }
      return disabled
    },
    buttonStylePlanned () {
      return (this.filterGroup === 'PLANNED' ? ' color: #606060 !important;' : '')
    },
    buttonStyleProduced () {
      return (this.filterGroup === 'PRODUCED' ? ' color: #606060 !important;' : '')
    },
    buttonStyleDelivered () {
      return (this.filterGroup === 'DELIVERED' ? ' color: #606060 !important;' : '')
    },
    buttonStyleRepacked () {
      return (this.filterGroup === 'REPACKED' ? ' color: #606060 !important;' : '')
    },
    buttonStyleDeleted () {
      return (this.filterGroup === 'DELETED' ? ' color: #606060 !important;' : '')
    },
    tableHeaders () {
      return this.isShowingProducedPallets ? this.producedHeaders : this.headers
    },
    filteredPallets () {
      let pallets = []
      if (this.pallets && this.search !== '') {
        let searchString = this.search.toLowerCase()
        for (let p of this.pallets) {
          if ((p.number && p.number.includes(searchString)) || (p.externalNumber && p.externalNumber.includes(searchString)) ||
            ((p.shipmentNumber && p.shipmentNumber.toLowerCase().includes(searchString)) || (p.plannedShipmentNumber && p.plannedShipmentNumber.toLowerCase().includes(searchString))) ||
            (p.stateLabel && p.stateLabel.toLowerCase().includes(searchString)) ||
            (p.supplier && p.supplier.toLowerCase().includes(searchString)) ||
            (p.categories && p.categories.toLowerCase().includes(searchString)) ||
            (p.amounts && p.amounts.toLowerCase().includes(searchString)) ||
            (p.pickupDate && p.pickupDate.toLowerCase().includes(searchString))) {
            pallets.push(p)
          }
        }
      } else {
        pallets = this.pallets
      }
      return pallets
    },
    pagedPallets () {
      if (this.filteredPallets) {
        let start = (this.currentPage - 1) * this.palletsPerPage
        let end = start + this.palletsPerPage
        return this.filteredPallets.slice(start, end)
      }
      return []
    },
    canDelete: function () {
      return this.currentPallet && this.currentPallet.id > 0 && this.currentPallet.state !== 'DELETED'
    },
    canDeleteCategories: function () {
      let canDelete = false
      if (this.currentPallet && this.currentPallet.items && this.currentPallet.items.length > 0) {
        let nonDeletedCount = 0
        for (let item of this.currentPallet.items) {
          if (!item.deleted) {
            nonDeletedCount++
          }
        }
        canDelete = nonDeletedCount > 0
      }
      return canDelete
    },
    users: function () {
      return this.$store.state.user.users
    },
    saveInternalTransportLogButtonEnabled: function () {
      return this.currentInternalTransportLog && this.timestampDate !== '' && this.timestampTime !== '' && this.currentInternalTransportLog.userName && (this.currentInternalTransportLog.action === 'LOAD' || (this.currentInternalTransportLog.address && this.currentInternalTransportLog.address.id > 0))
    },
    palletsPerPage: function () {
      return this.isShowingProducedPallets ? 10000 : 250
    },
    isShowingProducedPallets: function () {
      return this.filterGroup === 'PRODUCED'
    },
    isShowingDeliveredPallets: function () {
      return this.filterGroup === 'DELIVERED'
    },
    canPrint: function () {
      return this.pallets && this.pallets.length > 0 && (!this.$refs.pallets || this.$refs.pallets.filteredItems.length > 0)
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    timestampAllowedSteps: m => m % 5 === 0,
    filterByPlanned () {
      this.filterGroup = 'PLANNED'
      this.loadPallets()
    },
    filterByProduced () {
      this.filterGroup = 'PRODUCED'
      this.loadPallets()
    },
    filterByDelivered () {
      this.filterGroup = 'DELIVERED'
      this.loadPallets()
    },
    filterByRepacked () {
      this.filterGroup = 'REPACKED'
      this.loadPallets()
    },
    filterByDeleted () {
      this.filterGroup = 'DELETED'
      this.loadPallets()
    },
    loadPallets (palletToOpen) {
      // console.log('Loading pallets')
      axios.get('/backend/rest/pallet/summary/' + this.filterGroup + '?customer=' + this.filterCustomer.id + '&supplier=' + this.filterSupplier.id + '&category=' + (this.filterCategory ? this.filterCategory.id : 0) + '&shipment=' + this.filterShipmentNumber + '&location=' + this.filterLocation.id)
        .then(response => {
          this.pallets = response.data
          // console.log('Found ' + this.pallets.length + ' pallets')
          this.lastPage = Math.ceil(this.filteredPallets.length / this.palletsPerPage)
          if (this.currentPage > this.lastPage) {
            this.currentPage = 1
          }
          if (this.filteredPallets && this.filteredPallets.length > 0 && palletToOpen) {
            let foundPallet = false
            for (let p of this.filteredPallets) {
              if (p.id === palletToOpen.id) {
                foundPallet = true
                this.loadPallet(p)
                break
              }
            }
            if (!foundPallet) {
              this.currentPallet = null
            }
          } else {
            this.currentPallet = null
          }
        })
    },
    loadPallet (palletSummary) {
      let palletId = palletSummary.id
      // console.log('Loading pallet ' + palletId)
      axios.get('/backend/rest/pallet/' + palletId)
        .then(response => {
          this.currentPallet = response.data
          this.loadFields()
        })
    },
    loadCustomers () {
      // console.log('Loading locations')
      axios.get('/backend/rest/customer')
        .then(response => {
          this.customers = response.data
          this.customers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadCategories () {
      axios.get('/backend/rest/category')
        .then(response => {
          this.categories = response.data
          this.categories.splice(0, 0, {
            id: 0,
            label: ''
          })
        })
    },
    loadShipmentNumbers () {
      axios.get('/backend/rest/shipment/number')
        .then(response => {
          this.shipmentNumbers = response.data
          this.shipmentNumbers.splice(0, 0, '')
        })
    },
    loadLocations () {
      // console.log('Loading locations')
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          // console.log('Pickup addresses: ' + JSON.stringify(response.data))
          this.locations = response.data
          this.locations.splice(0, 0, {
            id: 0,
            text: ''
          })
        })
    },
    loadPickupAddresses () {
      // console.log('Loading pickup addresses')
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          // console.log('Pickup addresses: ' + JSON.stringify(response.data))
          this.pickupAddresses = response.data
        })
    },
    loadSuppliers () {
      // console.log('Loading suppliers')
      axios.get('/backend/rest/supplier')
        .then(response => {
          // console.log('Suppliers: ' + JSON.stringify(response.data))
          this.suppliers = response.data
          this.filterSuppliers = []
          for (let s of this.suppliers) {
            this.filterSuppliers.push(s)
          }
          this.filterSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadFields () {
      let fieldId = this.currentPallet && this.currentPallet.field ? this.currentPallet.field.id : 0
      axios.get('/backend/rest/field/supplier/' + this.currentPallet.supplier.id)
        .then(response => {
          this.fields = response.data
          if (this.fields && this.fields.length > 0) {
            this.fields.splice(0, 0, {
              id: 0,
              address: {
                nameAndText: ''
              }
            })
            if (fieldId > 0) {
              for (let f of this.fields) {
                if (f.id === fieldId) {
                  this.currentPallet.field = f
                  break
                }
              }
            } else {
              this.currentPallet.field = this.fields[0]
            }
          } else {
            this.currentPallet.field = null
          }
        })
    },
    loadContractors () {
      axios.get('/backend/rest/contractor')
        .then(response => {
          this.contractors = response.data
          this.contractors.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadInternalCarriers () {
      // console.log('Loading internal carriers')
      axios.get('/backend/rest/carrier')
        .then(response => {
          this.internalCarriers = response.data
          this.internalCarriers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadOptions () {
      axios.get('/backend/rest/option')
        .then(response => {
          this.options = response.data
        })
    },
    changeSupplier () {
      this.loadFields()
    },
    selectPallet (item) {
      // console.log('Select pallet ' + item.number)
      this.loadPallet(item)
    },
    create () {
      // console.log('Save pallet ' + this.currentPallet.number)
      axios.post('/backend/rest/pallet', this.currentPallet)
        .then(response => {
          // console.log('Got response: ' + response)
          let newPallet = response.data
          this.filterGroup = 'PRODUCED'
          this.loadPallets(newPallet)
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    save () {
      // console.log('Save pallet ' + this.currentPallet.number)
      axios.post('/backend/rest/pallet', this.currentPallet)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadPallets()
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    delete () {
      // console.log('Delete pallet ' + this.currentPallet.number)
      axios.delete('/backend/rest/pallet/' + this.currentPallet.id)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadPallets()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentPallet = null
    },
    cancel () {
      this.currentPallet = null
    },
    previousPage () {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    nextPage () {
      if (this.currentPage < this.lastPage) {
        this.currentPage += 1
      }
    },
    rowColor: function (pallet) {
      let color = 'selectable'
      if (pallet.categoryMissing && pallet.state !== 'PLANNED' && pallet.state !== 'IN_PRODUCTION') {
        color += ' categoryMissing'
      } else if (pallet.half) {
        color += ' half'
      } else if (pallet.state === 'IN_TRANSPORT') {
        color += ' inTransport'
      }
      return color
    },
    editNewPallet () {
      // console.log('Create a new pallet')
      this.currentPallet = {
        id: 0,
        uuid: null,
        number: null,
        shipmentNumber: null,
        state: 'READY_FOR_PICKUP',
        stateLabel: null,
        supplier: null,
        field: null,
        contractor: null,
        internalCarrier: null,
        location: null,
        position: 0,
        half: false,
        externalNumber: '',
        createdByAdmin: true,
        items: [
          {
            id: 0,
            category: null,
            plannedAmount: 0,
            amount: null,
            options: []
          }
        ]
      }
    },
    addCategory () {
      this.currentPallet.items.push(
        {
          id: -this.currentPallet.items.length,
          category: null,
          plannedAmount: 0,
          amount: null,
          options: []
        }
      )
    },
    confirmDeleteCategory (index) {
      this.deleteCategoryIndex = index
      this.confirmDeleteCategoryDialog = true
    },
    deleteCategory () {
      let item = this.currentPallet.items[this.deleteCategoryIndex]
      if (item.id > 0) {
        item.deleted = true
      } else {
        this.currentPallet.items.splice(this.deleteCategoryIndex, 1)
        let i = 0
        for (let it of this.currentPallet.items) {
          if (it.id <= 0) {
            it.id = i
            i--
          }
        }
      }
      this.confirmDeleteCategoryDialog = false
    },
    updatePlannedAmount (item) {
      item.plannedAmount = this.currentPallet.half ? item.category.halfPalletAmount : item.category.palletAmount
    },
    changeCategory (item) {
      this.updatePlannedAmount(item)
    },
    changeHalfPallet () {
      if (this.currentPallet.createdByAdmin) {
        for (let item of this.currentPallet.items) {
          this.updatePlannedAmount(item)
        }
      }
    },
    loadInternalTransportLogs () {
      this.internalTransportLogs = []
      axios.get('/backend/rest/internal_transport_log/' + this.currentPallet.id)
        .then(response => {
          this.internalTransportLogs = response.data
        })
    },
    startViewInternalTransportLog () {
      this.loadInternalTransportLogs()
      this.$store.dispatch('user/loadUsers')
      this.viewInternalTransportLog = true
    },
    startCreateInternalTransportLog () {
      this.timestampDate = ''
      this.timestampTime = ''
      this.currentInternalTransportLog = {
        id: null,
        timestamp: null,
        action: 'LOAD',
        userName: null,
        pallet: this.currentPallet,
        address: null
      }
    },
    saveInternalTransportLog () {
      this.currentInternalTransportLog.timestamp = this.timestampDate + ' ' + this.timestampTime
      axios.post('/backend/rest/internal_transport_log', this.currentInternalTransportLog)
        .then(response => {
          this.loadInternalTransportLogs()
          this.currentInternalTransportLog = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    cancelCreateInternalTransportLog () {
      this.currentInternalTransportLog = null
    },
    endViewInternalTransportLog () {
      this.viewInternalTransportLog = false
    },
    loadLogs () {
      this.logs = []
      axios.get('/backend/rest/log/pallet/' + this.currentPallet.id)
        .then(response => {
          this.logs = response.data
        })
    },
    startViewLog () {
      this.loadLogs()
      this.viewLog = true
    },
    endViewLog () {
      this.viewLog = false
    },
    print () {
      let filteredItems = this.$refs.pallets.filteredItems
      let palletIds = []
      for (let pallet of filteredItems) {
        palletIds.push(pallet.id)
      }
      let params = 'pallets=' + palletIds.join(',')
      params += '&filterGroup=' + this.filterGroup
      axios.post('/backend/print/pallets.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Pallets.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Pallets.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    }
  },
  watch: {
    search (val) {
      this.lastPage = Math.ceil(this.filteredPallets.length / this.palletsPerPage)
      if (this.currentPage > this.lastPage) {
        this.currentPage = 1
      }
    },
    sessionSalesOrganizations () {
      this.loadCustomers()
      this.loadShipmentNumbers()
      this.loadSuppliers()
      this.loadPallets()
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Pallets.vue